import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setViewRedrive, markTaskRedriving } from "../redux/executionTasksSlice"
import redriveFleetExecutionTask from '../services/redriveFleetExecutionTask'

export function extractRedriveError(err: any): string {
    if (!err?.response) {
        if (err?.code === 'ECONNABORTED') {
            return "Redrive timed out before the server responded. It may still have started — refresh in a moment."
        }
        return "Couldn't reach the server. Check your connection and try again."
    }
    const data = err.response.data
    if (typeof data === 'string' && data.trim()) return data.trim()
    const message = data?.message ?? data?.detail
    if (typeof message === 'string' && message.trim()) return message.trim()
    const status = err.response.status
    return status ? `Redrive failed (HTTP ${status}). Please try again.` : "Redrive failed. Please try again."
}

export default function useModalRedrive(){
    const [loading, setLoading] = useState<Boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const dataRedrive = useSelector((state: any) => state.executionTask.dataRedrive)
    const dispatch = useDispatch()

    const cancelMd = () => {
        setError(null)
        dispatch(setViewRedrive({view: false, data: null}))
    }

    const confirmMd = () => {
        setLoading(true)
        setError(null)
        redriveFleetExecutionTask(dataRedrive.fleet_execution_id, dataRedrive.fleet_execution_task_id)
        .then(() => {
            dispatch(markTaskRedriving({
                fleet_execution_id: dataRedrive.fleet_execution_id,
                fleet_execution_task_id: dataRedrive.fleet_execution_task_id,
            }))
            dispatch(setViewRedrive({view: false, data: null}))
        })
        .catch(err => {
            setError(extractRedriveError(err))
        })
        .finally(() => setLoading(false))
    }

    return {cancelMd, confirmMd, dataRedrive, loading, error}
}
